import { create } from 'zustand';

import type { User, Masters } from '@/interfaces';

interface AppStoreState {
  user: User | null;
  setUser: (user: User | null) => void;
  masters: Masters;
  setMasters: (masters: Masters) => void;
  isLoadingMasters: boolean;
  setIsLoadingMasters: (isLoadingMasters: boolean) => void;
  showReportIssueModal: boolean;
  setShowReportIssueModal: (show: boolean) => void;
}

const useAppStore = create<AppStoreState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  masters: { companies: [], plants: [] },
  setMasters: (masters) => set({ masters }),
  isLoadingMasters: true,
  setIsLoadingMasters: (isLoadingMasters) => set({ isLoadingMasters }),
  showReportIssueModal: false,
  setShowReportIssueModal: (show) => set({ showReportIssueModal: show }),
}));

export default useAppStore;
